import { createStore } from 'vuex';
// import user from './modules/user';
import layout from './modules/layout';

// 自动引入modules文件夹下的所有模块
// require.context 是webpack加的方法
// 路径 ,是否子目录, 读文件的标识
const autoImportModules = { layout };
const moduleFiles = require.context('./modules', true, /\.js$/);
moduleFiles.keys()
  .forEach(filepath => {
    let moduleObj = moduleFiles(filepath);
    let reg = /.*\/(.*)\.js$/;
    let moduleName = reg.exec(filepath)[1];
    if (!autoImportModules[moduleName] && moduleObj.default) {
      autoImportModules[moduleName] = moduleObj.default;
    }
  });

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: autoImportModules
});
